/*
 * @Author: Chao Yang
 * @Date: 2019-12-10 08:00:28
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-05-20 17:10:05
 */
import {
  AfterViewInit,
  OnDestroy,
  OnInit,
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  NgZone,
  Renderer2,
  ChangeDetectorRef,
} from '@angular/core';

@Directive({
  selector: '[adStickyFill]',
})
export class AlterDomusStickyFillDirective
  implements AfterViewInit, OnInit, OnDestroy {
  @Input()
  disable = false;
  menuPosition: number;
  @HostBinding('class.adStickyFill')
  sticky = false;

  removeWindowEvent: any;

  constructor(
    private element: ElementRef,
    private zone: NgZone,
    private renderer: Renderer2,
    private cd: ChangeDetectorRef
  ) { }
  ngOnDestroy(): void {
    if (this.removeWindowEvent) {
      this.removeWindowEvent();
    }
  }
  ngOnInit(): void {
    this.zone.runOutsideAngular(() => {
      this.removeWindowEvent = this.renderer.listen('window', 'scroll', () => {
        const windowScroll = window.pageYOffset;
        const oldSticky = this.sticky;
        // if it is triggered by using cdk overlay popup, we skip the sticky status change
        const iscdkoverlaypopup = document.documentElement?.classList?.contains('cdk-global-scrollblock') || false;
        if (iscdkoverlaypopup) {
          return;
        }
        if (this.disable === false) {
          this.sticky = windowScroll >= this.menuPosition;
        } else {
          this.sticky = false;
        }
        if (oldSticky !== this.sticky) {
          this.cd.detectChanges();
        }
      });
    });
  }

  ngAfterViewInit(): void {
    this.menuPosition = this.element.nativeElement.offsetTop;
  }
}
